<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days_ma1"
        :items="ma_days"
        label="1st Moving Avg Days"
        hint="Moving Average"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days_ma1', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.above_below"
        :items="above_below"
        label="above or below"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>

    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days_ma2"
        :items="ma_days"
        label="2nd Moving Avg Days"
        hint="Moving Average"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days_ma2', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.atr"
        density="compact"
        label="# ATRs"
        hint="MA 1 must be above or below MA 2 by at least ### ATRs (4-week)"
        variant="outlined"
        @update:model-value="updateConfig('atr', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      ma_days: [],
      above_below: ['above', 'below'],
      high_low: ['new high', 'new low'],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ],
      editedIndex: -1,
      editedMa: {
        rule_type: 'ma',
        enabled: true,
        above_below: 'above',
        days_ma1: 50,
        days_ma2: 200,
        atr: 2,
        long_short: 'long'
      },
      defaultMa: {
        rule_type: 'ma',
        enabled: true,
        above_below: 'above',
        days_ma1: 50,
        days_ma2: 200,
        atr: 2,
        long_short: 'long'
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    for (var i = 2; i < 71; i++) {
      this.ma_days.push(i)
    }
    for (i = 75; i < 301; i += 5) {
      this.ma_days.push(i)
    }
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'ma') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultMa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
